module.exports = __webpack_public_path__ + "static/media/mastercard.5450f163.svg";